export function* AssetSaga() {}
